import _ from 'lodash'
import { isImmutable, List, Map } from 'immutable'
import * as actionTypes from './actionTypes'
import { getAxios, getPreviewDynamicData } from '../../lib/projectAxios'
import uuid from 'uuid/v4'
import { IS_SERVER } from '../../constants/ssr'
import { processWidgetSFMapping } from './processWidgetSFMapping'
import { processSFAutoTrigger } from './processSFAutoTrigger'
import { processRules } from './processRules'
import { processPageOnLoad } from './processPageOnLoad'
import { processShowModal } from './processShowModal'
import { wbChangeLangProject } from './wbChangeLangProject'
import { isAllowFeatureState } from '../../lib/web-license'
import { projectPreviewDetectLocationAPI } from './projectPreviewSetOnLoadData'
import { SURVEY_TYPE } from '../../constants/features'
import { projectProcessGetSurveyData } from './projectProcessGetSurveyData'
import { projectPreviewSelectPage } from './projectPreviewSelectPage'
import { getQueryVariable } from '../../lib/processPortalRules'

const axios = getAxios()

function replaceUrlParam(url, paramName, paramValue) {
  if (paramValue == null) {
    paramValue = ''
  }
  var pattern = new RegExp('\\b(' + _.escapeRegExp(paramName) + '=).*?(&|#|$)')
  if (url.search(pattern) >= 0) {
    return url.replace(pattern, '$1' + paramValue + '$2')
  }
  url = url.replace(/[?#]$/, '')
  return url + (url.indexOf('?') > 0 ? '&' : '?') + paramName + '=' + paramValue
}

export const concatParams = (str, params) => {
  if (_.isString(params) && _.size(params) > 0) {
    const paramsArray = String(params).split('&')
    let url = str
    _.each(paramsArray, (param) => {
      const [name, value] = String(param).split('=')
      if (url.indexOf(`${name}=`) === -1) {
        url = `${url}${url.indexOf('?') !== -1 ? '&' : '?'}${param}`
      } else {
        url = replaceUrlParam(url, name, value)
      }
    })
    return url
  } else {
    return str
  }
}

export const projectECommercePreviewNavigate =
  (pageID, updatePage, paramsStr = '') =>
  async (dispatch, getState) => {
    let state = getState()

    const currentPageID = state.getIn(['page'])
    const projectID = state.getIn(['project', 'URL'])
    let prjectURL = `/ftproject/${projectID}`
    if (state.getIn(['project', 'Settings', 'isCustomDomainOpened'], false)) {
      prjectURL = ''
    }
    const page = state.getIn(['project', 'Settings', 'eCommerce', 'pages', pageID])
    if (!IS_SERVER && isImmutable(page) && page.get('url')) {
      if (typeof window.history !== 'undefined' && typeof window.history.replaceState === 'function') {
        const query = String(window.location.href).split(window.location.origin + window.location.pathname)[1]
        window.history.replaceState(
          {
            _id: projectID,
            pageID: pageID,
          },
          '',
          concatParams(`${prjectURL}/${page.get('url')}${query}`, paramsStr)
        )
      }
      const el = document.getElementById('ft__builder__root__el')
      if (el) {
        try {
          el.scrollTo(0, 0)
        } catch (err) {
          console.error(err)
        }
      }
    }

    const isUserSignIn = Boolean(getPreviewDynamicData().user || getPreviewDynamicData().messageValue)
    const isPublic = state.getIn(['project', 'isPublic'], false)
    if (!isPublic && page?.get?.('access') !== 'public') {
      if (!isUserSignIn) {
        if (!IS_SERVER) {
          if (typeof window.history !== 'undefined' && typeof window.history.replaceState === 'function') {
            const query = String(window.location.href).split(window.location.origin + window.location.pathname)[1]
            window.history.replaceState(
              {
                _id: projectID,
                pageID: pageID,
              },
              '',
              concatParams(`${prjectURL}/${page.get('url')}${query}`, paramsStr)
            )
          }
          const el = document.getElementById('ft__builder__root__el')
          if (el) {
            try {
              el.scrollTo(0, 0)
            } catch (err) {
              console.error(err)
            }
          }
        }
        return updatePage('signin')
      }
    }

    updatePage(pageID)

    // if (pageID == state.get('page')) {
    //     return false;
    // }

    dispatch({
      type: actionTypes.PROJECT_SET_PREVIEW_PAGE,
      payload: {
        pageID: pageID,
      },
    })

    dispatch({
      type: actionTypes.PROJECT_SET_RESET_PAGE_PARAMS,
      payload: {
        currentPageID: currentPageID,
        goToPage: pageID,
      },
    })
    await dispatch(processWidgetSFMapping('onload', null, null, null))
    // await dispatch(processWidgetSFMapping('onload', null, null, null));
    await dispatch(processSFAutoTrigger(true))
    dispatch(processRules(false))
    dispatch(processPageOnLoad())
    return true
  }

export const projectPreviewNavigatePage = (pageID) => async (dispatch, getState) => {
  dispatch({
    type: actionTypes.PROJECT_SET_PREVIEW_PAGE,
    payload: {
      pageID: pageID,
    },
  })
}

export const safariOpenPublicPage = (pageID) => async (dispatch, getState) => {
  try {
    let state = getState()
    const page = state.getIn(['project', 'Pages'], List()).find((page) => page.get('_id') === pageID)
    if (page && isImmutable(page)) {
      dispatch({
        type: actionTypes.PROJECT_SET_RESET_PAGE_PARAMS,
        payload: {
          currentPageID: pageID,
          goToPage: pageID,
          isForce: true,
        },
      })
      dispatch(projectPreviewDetectLocationAPI())
      let lang = getQueryVariable('FTLang', '')
      dispatch(processWidgetSFMapping('onload', null, null, null, true, lang))
      dispatch(processRules(true))
      dispatch(processPageOnLoad())
      dispatch(processSFAutoTrigger(true))
      state = getState()
      if (state.getIn(['project', 'ProjectType']) === SURVEY_TYPE) {
        const uid = state.getIn(['pages', page?.get?.('_id'), 'Props', 'Grid', 0])
        if (state.getIn(['pages', page?.get?.('_id'), 'Props', 'elements', uid, 'type']) === 'PageConditionalForm') {
          dispatch(projectProcessGetSurveyData())
        }
      }
      return undefined
    } else {
      console.error('No page found', pageID)
    }
  } catch (error) {
    console.error('Cannot load page', error)
  }
}
export const loadPagePreviewData = (pageID) => async (dispatch, getState) => {
  try {
    let state = getState()
    const page = state.getIn(['project', 'Pages'], List()).find((page) => page.get('_id') === pageID)
    if (page && isImmutable(page)) {
      const { data, status } = await axios.get(`/webprojects/preview-page/${page?.get?.('url')}`)
      if (status === 200 && data.status) {
        dispatch({
          type: actionTypes.PROJECT_SET_PREVIEW_PAGE_DATA,
          payload: {
            pages: data?.pages ?? {},
            isForce: true,
          },
        })
        dispatch(projectPreviewSelectPage(pageID))
        dispatch({
          type: actionTypes.PROJECT_SET_RESET_PAGE_PARAMS,
          payload: {
            currentPageID: pageID,
            goToPage: pageID,
            isForce: true,
          },
        })
        dispatch(projectPreviewDetectLocationAPI())
        let lang = getQueryVariable('FTLang', '')
        dispatch(processWidgetSFMapping('onload', null, null, null, true, lang))
        dispatch(processRules(true))
        dispatch(processPageOnLoad())
        dispatch(processSFAutoTrigger(true))
        state = getState()
        if (state.getIn(['project', 'ProjectType']) === SURVEY_TYPE) {
          const uid = state.getIn(['pages', page?.get?.('_id'), 'Props', 'Grid', 0])
          if (state.getIn(['pages', page?.get?.('_id'), 'Props', 'elements', uid, 'type']) === 'PageConditionalForm') {
            dispatch(projectProcessGetSurveyData())
          }
        }
        return undefined
      } else {
        console.error('No page loaded from server', pageID)
      }
    } else {
      console.error('No page found', pageID)
    }
  } catch (error) {
    console.error('Cannot load page', error)
  }
}
export const projectPreviewNavigate =
  (pageID, updatePage, paramsStr = '', pageTarget = 'self', modalSize = {}, isForce) =>
  async (dispatch, getState) => {
    let state = getState()
    if (!isAllowFeatureState('PreviewPublish', state) && state.getIn(['project', 'Pages'], List()).size > 1) {
      return false
    }

    if (['e_catalog', 'e_product'].indexOf(pageID) > -1) {
      return false
    }

    const currentPageID = state.getIn(['page'])
    const projectID = state.getIn(['project', 'URL'])
    const isPublic = state.getIn(['project', 'isPublic'], false)
    let isUserSignIn = Boolean(getPreviewDynamicData().user || getPreviewDynamicData().messageValue)
    let ftSessLeftTime = state.getIn(['params', 'ftSessLeftTime'], 0)
    if (!ftSessLeftTime || ftSessLeftTime < 0) {
      isUserSignIn = false
    }
    const page = state
      .getIn(['project', 'Pages'], List())
      .find((page) => page.get('uid') === pageID || page.get('_id') === pageID)
    const pageURI = page?.get?.('url', '')
    const pages = state.get('pages', Map())

    let prjectURL = `/ftproject/${projectID}`
    if (state.getIn(['project', 'Settings', 'isCustomDomainOpened'], false)) {
      prjectURL = ''
    }

    const query = String(window.location.href).split(window.location.origin + window.location.pathname)[1]

    if (!pages.has(page?.get?.('_id')) || !pages.getIn([page?.get?.('_id'), '_id'])) {
      if (!isPublic && page?.get?.('access') !== 'public') {
        if (!isUserSignIn) {
          if (!IS_SERVER) {
            let url = concatParams(`${prjectURL}/${pageURI}${query}`, paramsStr)
            if (pageTarget === 'blank') {
              window.open(url, 'blank')
              return null
            } else if (pageTarget === 'parent') {
              try {
                if (window.parent) {
                  window.parent.location.href = url
                  return null
                }
              } catch (err) {
                console.error(err)
              }
            } else if (pageTarget === 'modal') {
              dispatch(
                processShowModal({
                  url: url,
                  width: modalSize?.width || '',
                  height: modalSize?.height || '',
                  params: List.of(paramsStr),
                })
              )
              return null
            } else {
              if (typeof window.history !== 'undefined' && typeof window.history.pushState === 'function') {
                const query = String(window.location.href).split(window.location.origin + window.location.pathname)[1]
                window.history.pushState(
                  {
                    _id: projectID,
                    pageID: page?.get?.('_id'),
                  },
                  '',
                  concatParams(`${prjectURL}/${pageURI}${query}`, paramsStr)
                )
              }
              const el = document.getElementById('ft__builder__root__el')
              if (el) {
                try {
                  el.scrollTo(0, 0)
                } catch (err) {
                  console.error(err)
                }
              }
            }
            dispatch(projectPreviewNavigatePage(pageID))
          }
          return updatePage('signin')
        } else if (state.getIn(['project', 'Settings', 'ac', 'enabled'])) {
          const smartvParameterValue = state.getIn(
            [
              'params',
              state
                .getIn(['project', 'params'], List())
                .find((param) => param.get('isACParam') === true)
                ?.get?.('id') || '_',
            ],
            ''
          )
          const rules = state.getIn(['project', 'Settings', 'ac', 'list'], List())
          //for now not have default rules
          // const defaultRule = rules.find(rule => rule.get('isDefault'))
          let targetRule = rules.find((rule) => rule.get('value') === smartvParameterValue)
          if (!targetRule) {
            targetRule = rules.find((rule) => rule.get('isFallback') && rule.get('enabled'))
          }
          if (!targetRule) {
            return window.__FT_PROJECT__API__.navigateToForbiddenPage()
          }
        }
      }
      try {
        if (page && page?.get?.('url')) {
          const { data, status } = await axios.get(`/webprojects/preview-page/${page?.get?.('url')}`)
          if (status === 200 && data.status) {
            dispatch({
              type: actionTypes.PROJECT_SET_PREVIEW_PAGE_DATA,
              payload: {
                pages: data?.pages ?? {},
                isForce,
              },
            })
            dispatch(wbChangeLangProject(state.get('FTLang'), pageID))
            let url = concatParams(`${prjectURL}/${pageURI}${query}`, paramsStr)
            if (pageTarget === 'blank') {
              window.open(url, 'blank')
              return null
            } else if (pageTarget === 'parent') {
              if (window.parent) {
                window.parent.location.href = url
                return null
              }
            } else if (pageTarget === 'modal') {
              dispatch(
                processShowModal({
                  url: url,
                  width: modalSize?.width || '',
                  height: modalSize?.height || '',
                  params: List.of(paramsStr),
                })
              )
              return null
            } else {
              updatePage('preview')
              if (!IS_SERVER) {
                if (typeof window.history !== 'undefined' && typeof window.history.replaceState === 'function') {
                  const query = String(window.location.href).split(window.location.origin + window.location.pathname)[1]
                  window.history.replaceState(
                    {
                      _id: projectID,
                      pageID: page?.get?.('_id'),
                    },
                    '',
                    concatParams(`${prjectURL}/${pageURI}${query}`, paramsStr)
                  )
                }
                const el = document.getElementById('ft__builder__root__el')
                if (el) {
                  try {
                    el.scrollTo(0, 0)
                  } catch (err) {
                    console.error(err)
                  }
                }
              }
              dispatch(projectPreviewNavigatePage(pageID))
            }
          } else {
            window.__FT_PROJECT__API__.navigateToSignInPage()
            return false
          }
        }
      } catch (error) {
        console.error(error)
        dispatch({
          type: actionTypes.NOTIFY_ERROR,
          payload: {
            key: uuid(),
            message: `Network error. Please try again later.`,
          },
        })
        return false
      }
    } else {
      if (!isPublic && page?.get?.('access') !== 'public') {
        if (!isUserSignIn) {
          if (!IS_SERVER) {
            let url = concatParams(`${prjectURL}/${pageURI}${query}`, paramsStr)
            if (pageTarget === 'blank') {
              window.open(url, 'blank')
              return null
            } else if (pageTarget === 'parent') {
              try {
                if (window.parent) {
                  window.parent.location.href = url
                  return null
                }
              } catch (err) {
                console.error(err)
              }
            } else if (pageTarget === 'modal') {
              dispatch(
                processShowModal({
                  url: url,
                  width: modalSize?.width || '',
                  height: modalSize?.height || '',
                  params: List.of(paramsStr),
                })
              )
              return null
            } else {
              if (typeof window.history !== 'undefined' && typeof window.history.replaceState === 'function') {
                const query = String(window.location.href).split(window.location.origin + window.location.pathname)[1]
                window.history.replaceState(
                  {
                    _id: projectID,
                    pageID: page?.get?.('_id'),
                  },
                  '',
                  concatParams(`${prjectURL}/${pageURI}${query}`, paramsStr)
                )
              }
            }
            const el = document.getElementById('ft__builder__root__el')
            if (el) {
              try {
                el.scrollTo(0, 0)
              } catch (err) {
                console.error(err)
              }
            }
            dispatch(projectPreviewNavigatePage(pageID))
          }
          return updatePage('signin')
        } else if (state.getIn(['project', 'Settings', 'ac', 'enabled'])) {
          const smartvParameterValue = state.getIn(
            [
              'params',
              state
                .getIn(['project', 'params'], List())
                .find((param) => param.get('isACParam') === true)
                ?.get?.('id') || '_',
            ],
            ''
          )
          const rules = state.getIn(['project', 'Settings', 'ac', 'list'], List())
          //for now not have default rules
          // const defaultRule = rules.find(rule => rule.get('isDefault'))
          let targetRule = rules.find((rule) => rule.get('value') === smartvParameterValue)
          if (!targetRule) {
            targetRule = rules.find((rule) => rule.get('isFallback') && rule.get('enabled'))
          }
          if (!targetRule) {
            return window.__FT_PROJECT__API__.navigateToForbiddenPage()
          }
        }
      }
    }
    // if (page && page.has('action')) {
    //     dispatch(processButtonAction(page.getIn(['action'], Map()).toJS(), page?.get?.('_id'), false, null));
    // }
    let url = concatParams(`${prjectURL}/${pageURI}${query}`, paramsStr)
    if (pageTarget === 'blank') {
      window.open(url, 'blank')
      return null
    } else if (pageTarget === 'parent') {
      if (window.parent) {
        window.parent.location.href = url
        return null
      }
    } else if (pageTarget === 'modal') {
      dispatch(
        processShowModal({
          url: url,
          width: modalSize?.width || '',
          height: modalSize?.height || '',
          params: List.of(paramsStr),
        })
      )
      return null
    } else {
      dispatch({
        type: actionTypes.PROJECT_SET_PREVIEW_PAGE,
        payload: {
          pageID: page?.get?.('_id'),
          isForce,
        },
      })
      updatePage('preview')
      if (!IS_SERVER && pageURI !== undefined) {
        if (typeof window.history !== 'undefined' && typeof window.history.replaceState === 'function') {
          const query = String(window.location.href).split(window.location.origin + window.location.pathname)[1]
          window.history.replaceState(
            {
              _id: projectID,
              pageID: page?.get?.('_id'),
            },
            '',
            concatParams(`${prjectURL}/${pageURI}${query}`, paramsStr)
          )
        }
        const el = document.getElementById('ft__builder__root__el')
        if (el) {
          try {
            el.scrollTo(0, 0)
          } catch (err) {
            console.error(err)
          }
        }
      }

      if (page?.get?.('_id') == state.get('page') && !isForce) {
        return false
      }

      dispatch({
        type: actionTypes.PROJECT_SET_RESET_PAGE_PARAMS,
        payload: {
          currentPageID: currentPageID,
          goToPage: page?.get?.('_id'),
          isForce,
        },
      })
      dispatch(projectPreviewDetectLocationAPI())
      await dispatch(processWidgetSFMapping('onload', null, null, null))
      // await dispatch(processWidgetSFMapping('onload', null, null, null));
      dispatch(processSFAutoTrigger(true))
      dispatch(processRules(false))
      dispatch(processPageOnLoad())
      state = getState()
      if (state.getIn(['project', 'ProjectType']) === SURVEY_TYPE) {
        const uid = state.getIn(['pages', page?.get?.('_id'), 'Props', 'Grid', 0])
        if (state.getIn(['pages', page?.get?.('_id'), 'Props', 'elements', uid, 'type']) === 'PageConditionalForm') {
          dispatch(projectProcessGetSurveyData())
        }
      }
    }
    return true
  }
